









































































































































































import Vue from 'vue'
import ConfidenceLevel from './ConfidenceLevel.vue'
import SectionInfo from './SectionInfo.vue'
import SectionTitle from './SectionTitle.vue'
import Score from '../Score/Score.vue'
import ScoreExplained from './ScoreExplained.vue'

export default Vue.extend({
  name: 'Summary',
  components: {
    ConfidenceLevel,
    SectionInfo,
    SectionTitle,
    Score,
    ScoreExplained
  },
  props: {
    checkId: {
      type: String,
      default: '',
      required: true
    },
    score: {
      type: Number,
      default: 0,
      required: true
    },
    scoreByID: {
      type: Number,
      default: 0,
      required: true
    },
    scoreByName: {
      type: Number,
      default: 0,
      required: true
    },
    name: {
      type: String,
      default: '',
      required: true
    },
    lastname: {
      type: String,
      default: '',
      required: true
    },
    identificationNumber: {
      type: String,
      default: ''
    },
    country: {
      type: String,
      default: '',
      required: true
    },
    creationDate: {
      type: String,
      required: true
    },
    status: {
      type: String,
      default: '',
      required: true
    },
    showDatasourcesStatus: {
      type: Function,
      default: () => {}
    },
    updateCheck: {
      type: Function,
      default: () => {}
    }
  },
  data: () => ({
    scoreType: 'global',
    showMoreInformation: false,
    icons: {
      contentCopy: 'icon-pneuma-copy-outline',
      language: 'icon-pneuma-planet-time-outline'
    },
    statuses: {
      completed: 'Completado',
      inProgress: 'En progreso',
      delayed: 'Paricalmente consultado'
    }
  }),
  methods: {
    changeScoreExplanationVisibility (value: boolean) {
      this.showMoreInformation = value
    },
    copyToClipboard: async function () {
      try {
        // await navigator.clipboard.writeText(this.checkId as any)
      } catch (e) {
        console.log('Copy is not supported', e)
      }
    },
    generatePDF () {
      const filePath = 'https://firebasestorage.googleapis.com/v0/b/truchecks-515e8.appspot.com/o/Truora_CHKf0d802cc537e3f2e63d7d8961bf9b581.pdf?alt=media&token=aa5c6385-6648-40ac-9659-7f6f16a99219'
      const a: HTMLAnchorElement = document.createElement('a')
      a.href = filePath
      a.target = '_blank'
      a.download = filePath.substr(filePath.lastIndexOf('/') + 1)
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    cleanField (fieldValue: string): string {
      if (!fieldValue || fieldValue === '') {
        return this.$tc('No encontrado')
      }

      return fieldValue
    }
  },
  computed: {
    visibleScore (): number {
      if (this.scoreType === 'global') {
        return Math.round(this.score as any * 10)
      }

      if (this.scoreType === 'id') {
        return Math.round(this.scoreByID as any * 10)
      }

      return Math.round(this.scoreByName as any * 10)
    },
    countryName () {
      const countriesMap = {
        CO: 'Colombia',
        MX: 'México',
        CL: 'Chile',
        BR: 'Brazil'
      } as Record<string, any>

      return countriesMap[this.country as string]
    },
    statusName () {
      const statusNamesMap = {
        completed: this.statuses.completed,
        in_progress: this.statuses.inProgress,
        'in-progress': this.statuses.inProgress,
        delayed: this.statuses.delayed
      } as Record<string, any>

      return statusNamesMap[this.status as string]
    },
    statusColor () {
      const statusColorsMap = {
        completed: '#12d67d',
        in_progress: '#131313',
        'in-progress': '#131313',
        delayed: '#f95a59'
      } as Record<string, any>

      return statusColorsMap[this.status as string]
    },
    creationDateText () {
      const date = new Date(this.creationDate)

      return date.toLocaleDateString(navigator.language, {
        day: 'numeric',
        weekday: 'long',
        month: 'long'
      })
    },
    creationHour () {
      const date = new Date(this.creationDate)

      return date.toLocaleTimeString(navigator.language, {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        timeZoneName: 'long'
      })
    }
  },
  mounted () {
    // @ts-ignore
    this.statuses = {
      // @ts-ignore
      completed: this.$t('Completada'),
      // @ts-ignore
      inProgress: this.$t('En progreso'),
      // @ts-ignore
      delayed: this.$t('Parcialmente consultada')
    }
  }
})
